import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, catchError} from 'rxjs/operators';
import {combineLatest, of} from 'rxjs';
import {ApiService} from '../../../core/http/api.service';
import {LoadUserDetailsActionParams} from '../../models/user.model';
import {GetUserDetailsByIdResponseModel, GetUserUploadsResponseModel} from '../../../shared/models/users/users.models';
import { AgentDetailsActions } from '../../actions/user/agent-details.actions';

@Injectable()
export class AgentDetailsEffects {

   loadAgentDetails$ = createEffect(() => this.actions$
    .pipe(
      ofType(AgentDetailsActions.loadAgentDetails),
      mergeMap(
        (data: LoadUserDetailsActionParams) => combineLatest( [this.api.Users.getUserDetailsById(data.id, data.params), this.api.Uploads.getUserUploads(data.id) ])
          .pipe(
            map((response: [GetUserDetailsByIdResponseModel, GetUserUploadsResponseModel]) => {
              const userDetails = response[0]?.data;
              const userUploads = response[1]?.data;
              const userData = {...userDetails, uploads: userUploads};
              return AgentDetailsActions.loadAgentSuccess({data: userData});
            }),
            catchError(error => of(AgentDetailsActions.loadAgentFailure(error)))
          )
      )
    ));

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {}
}
